'use client';

import { Children, cloneElement } from 'react';

import { useMenuContext } from './MenuProvider';

import type { FC, ReactNode } from 'react';

export interface ToggleProps {
  children: ReactNode;
}

export const MenuToggle: FC<ToggleProps> = ({ children }) => {
  const { onClick, open } = useMenuContext();

  return (
    <>
      {Children.map( children, (child) =>
        cloneElement( child, {
          onClick,
          'aria-controls': open ? 'menu' : void 0,
          'aria-haspopup': 'true',
          'aria-expanded': open ? 'true' : void 0,
        } ) )}
    </>
  );
};
